import { render, staticRenderFns } from "./CreateBudgetSimulation.vue?vue&type=template&id=77bf3abe&scoped=true&"
import script from "./CreateBudgetSimulation.vue?vue&type=script&lang=js&"
export * from "./CreateBudgetSimulation.vue?vue&type=script&lang=js&"
import style0 from "./CreateBudgetSimulation.vue?vue&type=style&index=0&id=77bf3abe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf3abe",
  null
  
)

export default component.exports